// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Buefy from 'buefy';
//import 'bulma/css/bulma.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faPowerOff, faUser, faTachometerAlt, faUserGraduate, faUserTie, faAtlas, faWrench, faQrcode, faEdit, faTrashAlt, faUserCheck, faUserFriends, faCheck, faCheckSquare, faTv, faCalendar, faFileUpload, faUsers, faBell, faFileExcel, faGlobe, faEnvelope, faBook, faCaretDown, faCaretUp, faTimes, faAngleDoubleDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Photoshop } from 'vue-color'
import vSelect from 'vue-select'
import VModal from 'vue-js-modal'
import { store } from './store'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VueGtag from "vue-gtag";
import ProgressBar from 'vuejs-progress-bar'

Vue.use(VueGtag, {
  config: { id: "G-G7T00JGRMW" }
}, router);

Vue.config.productionTip = false
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});
Vue.use(VueTimepicker);
Vue.use(VModal, {dynamic: true})
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
 
Vue.use(VueSweetalert2, options)
Vue.use(ProgressBar)
Vue.config.devtools = true

library.add(faCoffee)
library.add(faPowerOff)
library.add(faUser)
library.add(faTachometerAlt)
library.add(faUserGraduate)
library.add(faUserTie)
library.add(faAtlas)
library.add(faWrench)
library.add(faQrcode)
library.add(faEdit)
library.add(faTrashAlt)
library.add(faUserCheck)
library.add(faUserFriends)
library.add(faCheck)
library.add(faCheckSquare)
library.add(faTv)
library.add(faCalendar)
library.add(faFileUpload)
library.add(faUsers)
library.add(faBell)
library.add(faFileExcel)
library.add(faGlobe)
library.add(faEnvelope)
library.add(faBook)
library.add(faCaretDown)
library.add(faCaretUp)
library.add(faTimes)
library.add(faAngleDoubleDown)
library.add(faArrowUp)

Vue.component('vue-fontawesome', FontAwesomeIcon)
Vue.component('v-select', vSelect)
Vue.component('vue-timepicker', VueTimepicker)


Vue.config.productionTip = false
Vue.prototype.$appName = 'StudentQR'
Vue.prototype.$hourToCacheData = 3
Vue.prototype.moment = moment


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, 'photoshop-picker': Photoshop, VueTimepicker  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js